import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ChatSidebar } from './ChatSidebar';
import { ChatHeader } from './ChatHeader';
import { useAuth } from '../hooks/useAuth';
import { Loader2 } from 'lucide-react';
import { ModelsProvider } from '../context/ModelsContext';

export const AgentsMeetupLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user, loading } = useAuth();

  // No authentication redirect - allow guest access

  // Show loading state while checking authentication (brief initial check only)
  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <ModelsProvider>
    <div className="flex h-dvh w-full overflow-hidden">
      {/* Sidebar - Desktop */}
      <aside 
        className={`hidden md:block border-r transition-all duration-300 ease-in-out ${
          sidebarCollapsed ? 'w-16' : 'w-[264px]'
        }`}
      >
        <ChatSidebar 
          collapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
          user={user}
        />
      </aside>

      {/* Sidebar - Mobile Overlay */}
      {sidebarOpen && (
        <>
          <div 
            className="fixed inset-0 bg-foreground/50 z-40 md:hidden animate-fade-in"
            onClick={() => setSidebarOpen(false)}
          />
          <aside className="fixed left-0 top-0 bottom-0 w-[min(88vw,320px)] bg-background z-50 md:hidden animate-slide-in-right">
            <ChatSidebar onClose={() => setSidebarOpen(false)} user={user} />
          </aside>
        </>
      )}

      {/* Main Content */}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <ChatHeader 
          onMenuClick={() => setSidebarOpen(true)}
        />
        
        <main className="min-h-0 min-w-0 flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
    </ModelsProvider>
  );
};
